<template lang="pug">
  #victimstates.text-xs-center
    v-card
      v-list.panel
        v-list-group(
          v-for="state in filteredVictimsStates"
          :key="state"
          sub-group
          no-action
        )
          v-list-tile(slot="activator")
            v-list-tile-content
              v-list-tile-title 
                span.accent-text.bold {{ state }} 
                | - {{stateVictims(state).length}} Víctima{{stateVictims(state).length > 1 ? 's': ''}}

          v-list-tile(v-for="(victim, index) in stateVictims(state)" :key="index")
            v-list-tile-content(@click="openPopUp(victim.advisoryFolio + '.' + victim.victimFolio)")
              v-list-tile-title.report {{victim.advisoryFolio + '.' + victim.victimFolio}}. {{victim.municipality}}, {{victim.year}}

</template>

<script>
export default {
  name: "VictimStates",
  props: {},
  computed: {
    victims: {
      get() {
        return this.$store.state.filteredVictims;
      }
    },
    filteredVictimsStates: {
      get() {
        return this.$store.state.filteredVictimsStates;
      },
      set(value) {
        this.$store.commit("setFilteredVictimsStates", value);
      }
    }
  },
  methods: {
    stateVictims(state) {
      return this.victims.filter(el => {
          return el.disappearancePlace == state;
        })
        .sort((a, b) => {
          return a.municipality - b.municipality || a.year - b.year;
        });
    },
    openPopUp(folio) {
      this.$store.commit("setVictimSelection", folio);
    }
  }
};
</script>

<style>
#victimstates .panel {
  height: 600px;
  overflow: scroll;
  border: 15px solid #eaeaea;
  padding: 0px;
  background-color: #f7f7f7;
}

.report {
  cursor: pointer;
}

.v-expansion-panel__header {
  padding: 0px 24px;
}

.v-list__group__header--sub-group .v-list__group__header__prepend-icon {
  padding: 0 0 0 1rem;
  margin: 0;
}
.theme--light.v-expansion-panel .v-expansion-panel__container {
  background-color: #f7f7f7;
}

.v-list__group__header {
  background-color: #f7f7f7;
  border-bottom: 1px solid #acacac;
}
.v-list__tile__title {
  font-family: "Open Sans", sans-serif;
  font-weight: bold;
  color: black;
  font-size: 12px;
}

.v-list__group__items--no-action .v-list__tile {
  background-color: #f7f7f7;
  padding-left: 30px;
  border-bottom: 1px solid #acacac;
}
</style>
